import {
  OrderDetails,
  LoadingSpinner,
  ModalMessage,
} from "../../components";
import { Container, Row, Col } from "react-bootstrap";
import { fetchOrderDetailsApi } from "../../api/ordersApi.js";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStorageToken, useLogout } from "../../utilities";

export default function UserOrderDetails() {
  // displays all details pertaining to the order 

  const { id } = useParams();
  const { stayLoggedIn } = useSelector((state) => state.user);
  const logout = useLogout();

  const [orderDetails, setOrderDetails] = useState(null);
  const [delivered, setDelivered] = useState({ status: false, date: null });
  const [paid, setPaid] = useState({ status: false, date: null });
  const [cancelled, setCancelled] = useState({ status: false });
  const [refunded, setRefunded] = useState({ status: false, date: null});
  const [returned, setReturned] = useState({ status: false, date: null });
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    const fetchOrderDetails = async (orderId) => {
      // returns array with jsons
      setIsLoading(true);
      try {
        const token = getStorageToken(stayLoggedIn);
        const res = await fetchOrderDetailsApi(token,
          orderId,
          abortController.signal
        );
        return res;
      } catch (error) {
        if (error?.status === 401) {  //unautorized, eg token expired
          logout();
        }
        setErrorMsg("Could not load data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrderDetails(id)
      .then((res) => {
        setOrderDetails(res);
        setDelivered({ status: res?.isDelivered, date: res?.deliveredAt });
        setPaid({ status: res?.isPaid, date: res?.paidAt });
        setCancelled({status: res?.isCancelled, date: res?.cancelledAt})
        setRefunded({status: res?.refunded, date: res?.refundedAt});
        setReturned({status: res?.returned, date: res?.returnedAt})
      })
      .catch((error) =>
        setErrorMsg("Could not load data. Please try again later.")
      );

      return () => abortController.abort();
  }, [stayLoggedIn, logout, id]);



  return (
    <Container className="mt-5 my-5">
      {errorMsg ? (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      ) : successMsg ? (
        <ModalMessage
          autoClose={true}
          type="success"
          message={successMsg}
          setSuccessMsg={setSuccessMsg}
        />
      ) : null}
      <Row>
        <Col>  
         <h1>Order Details</h1>
          {isLoading ? <LoadingSpinner /> : null}
          {orderDetails && (
            <OrderDetails
              order       
              data={orderDetails}
              delivered={delivered}
              paid={paid}
              cancelled={cancelled}
              refunded={refunded}
              returned={returned}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
}
